import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_403 implements Validator {

    public static id = 'CTRL_403';
    private message = 'error.ctr_403';


    public LOG: LogService = new LogService(CTRL_403);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_403.id + '_');

        if (rgs.length > 0) {
            for (let rg of rgs) {
                const ctrl = form.controls[rg];
                const critere = ctrl.value.rgCtrls.critere;
                const criterePCT = ctrl.value.rgCtrls.criterePCT;

                const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);
                const criterePondereIters = this.formExtractorService.getIndexes(Array.from(controls.keys()), ['_SepSep_CriterePondere_'], '_SepSep_TypeAnn_JOUE_18_SepSep_Criteres_index_');
                let nbCritere = 0;
                for (let i = 1; i <= criterePondereIters.size; i++) {
                    const critereCtrl = form.controls[map.get(critere.replace('INDEX_403_1', i))];
                    if (critereCtrl.value !== '') {
                        nbCritere++;
                    }
                }
                if (nbCritere < 1 || nbCritere > 1) {
                    let nbCriterePondere = 0;
                    for (let i = 1; i <= criterePondereIters.size; i++) {
                        const critereCtrl = form.controls[map.get(critere.replace('INDEX_403_1', i))];
                        const criterePCTCtrl = form.controls[map.get(criterePCT.replace('INDEX_403_1', i))];
                        if (critereCtrl.value !== '' && criterePCTCtrl.value !== null) {
                            nbCriterePondere++;
                        }
                    }
                    if (nbCriterePondere > 1) {
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                    } else {
                        // placer le message d'erreur
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                    }
                } else {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                }
                
            }
        }
    }
}
